import { render } from "./AddPaiementServicePage.vue?vue&type=template&id=1ae83d35&ts=true"
import script from "./AddPaiementServicePage.vue?vue&type=script&lang=ts"
export * from "./AddPaiementServicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__